import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";

export function* getInsuranceCompanies() {
  yield takeEvery(
    actions.FETCH_INSURANCE_COMPANIES_REQUESTED,
    function* (action) {
      try {
        const result = yield call(
          actions.getInsuranceCompanies,
          action.payload
        );
        yield put({
          type: actions.FETCH_INSURANCE_COMPANIES_SUCCEEDED,
          payload: result,
        });
      } catch (error) {
        yield put({
          type: actions.FETCH_INSURANCE_COMPANIES_FAILED,
          error: error.message,
        });
      }
    }
  );
}

export function* getInsuranceCompany() {
  yield takeEvery(
    actions.FETCH_INSURANCE_COMPANY_REQUESTED,
    function* (action) {
      try {
        const result = yield call(
          actions.getInsuranceCompany,
          action.payload
        );
        yield put({
          type: actions.FETCH_INSURANCE_COMPANY_SUCCEEDED,
          payload: result.insurance_company,
        });
      } catch (error) {
        yield put({
          type: actions.FETCH_INSURANCE_COMPANY_FAILED,
          error: error.message,
        });
      }
    }
  );
}

export function* deleteInsuranceCompany() {
  yield takeEvery(
    actions.DELETE_INSURANCE_COMPANY_REQUESTED,
    function* (action) {
      try {
        yield call(actions.deleteInsuranceCompany, action.payload);
        yield put({ type: actions.DELETE_INSURANCE_COMPANY_SUCCEEDED });
      } catch (error) {
        yield put({
          type: actions.DELETE_INSURANCE_COMPANY_FAILED,
          error: error.message,
        });
      }
    }
  );
}

export default function* rootSaga() {
  yield all([
    fork(getInsuranceCompanies),
    fork(getInsuranceCompany),
    fork(deleteInsuranceCompany),
  ]);
}
